<template>
  <b-button-group v-if="canView" class="wa-nav-badge">
    <b-button
      variant="light"
      v-b-tooltip.hover.bottom
      :title="tooltip"
      @click="goToReport"
    >
      <font-awesome-icon class="mr-2 color-primary" icon="stopwatch" />
      <span class="font-weight-bold mr-1">WhatsApp วันนี้</span>
      <b-spinner v-if="isLoading && !today" small></b-spinner>
      <template v-else-if="today && today.deliveredCount">
        <span>ถึงลูกค้าใน ~{{ median }}</span>
        <template v-if="today.pendingCount > 0">
          <span class="wa-nav-sep">·</span>
          <span>ยังไม่ถึง {{ today.pendingCount }}</span>
        </template>
      </template>
      <span v-else class="text-muted">ยังไม่มีข้อมูล</span>
    </b-button>
    <b-button
      variant="light"
      class="wa-nav-refresh"
      v-b-tooltip.hover.bottom
      title="รีเฟรชข้อมูล"
      :disabled="isLoading"
      @click="getToday(true)"
    >
      <font-awesome-icon
        icon="sync-alt"
        :class="{ 'wa-nav-spin': isLoading }"
      />
    </b-button>
  </b-button-group>
</template>

<script>
import { mapGetters } from "vuex";
import {
  WHATSAPP_REPORT_PATH,
  canViewWhatsappReport,
  fetchWhatsappDeliveryToday,
  formatDuration,
  within10sPercent
} from "@/helpers/whatsappDelivery";

// navbar แสดงตลอด → refresh ทุก 5 นาที
const REFRESH_MS = 5 * 60 * 1000;

export default {
  name: "WhatsappDeliveryNavBadge",
  data() {
    return {
      isLoading: false,
      today: null,
      timer: null
    };
  },
  computed: {
    ...mapGetters({
      brandID: "getBrand",
      adminProfile: "getChatAdminProfile"
    }),
    canView() {
      return canViewWhatsappReport(this.adminProfile) && !!this.brandID;
    },
    refreshKey() {
      return this.canView ? this.brandID : null;
    },
    median() {
      return formatDuration(
        this.today.deliveredMedianSeconds,
        this.today.deliveredCount
      );
    },
    within10s() {
      return within10sPercent(this.today);
    },
    tooltip() {
      if (!this.today || !this.today.deliveredCount)
        return "วันนี้ยังไม่มีข้อความ WhatsApp ที่ส่งถึงลูกค้า · คลิกเพื่อดูรายละเอียด";
      const pending = this.today.pendingCount
        ? ` อีก ${this.today.pendingCount} ข้อความยังไม่ถึง (มักเพราะมือถือลูกค้าปิดหรือไม่มีอินเทอร์เน็ต)`
        : "";
      return (
        `ข้อความ WhatsApp ที่ส่งวันนี้ ส่วนใหญ่ถึงมือถือลูกค้าภายใน ${this.median}` +
        ` และ ${this.within10s} ถึงภายใน 10 วินาที${pending} · คลิกเพื่อดูรายละเอียด`
      );
    }
  },
  watch: {
    // profile / brand โหลดทีหลัง component และเปลี่ยน brand ได้ → เริ่มดึงใหม่ทุกครั้ง
    refreshKey: {
      immediate: true,
      handler() {
        this.stopRefresh();
        this.today = null;
        if (!this.canView) return;
        this.getToday();
        this.timer = setInterval(this.getToday, REFRESH_MS);
      }
    }
  },
  beforeDestroy() {
    this.stopRefresh();
  },
  methods: {
    stopRefresh() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    },
    goToReport() {
      this.$router.push(`${WHATSAPP_REPORT_PATH}?brandID=${this.brandID}`);
    },
    // force = true (ปุ่ม refresh) → ข้าม cache 1 นาที
    async getToday(force = false) {
      if (this.isLoading) return;
      const brandId = this.brandID;
      this.isLoading = true;
      const result = await fetchWhatsappDeliveryToday(
        this.$chatBaseUrl,
        this.$headersChat,
        brandId,
        force === true
      );
      this.isLoading = false;
      // brand เปลี่ยนระหว่างรอ → ทิ้งผลของ brand เก่า
      if (brandId === this.brandID) this.today = result;
    }
  }
};
</script>

<style scoped>
.wa-nav-badge {
  white-space: nowrap;
  font-size: 14px;
}

.wa-nav-spin {
  animation: wa-nav-rotate 1s linear infinite;
}

@keyframes wa-nav-rotate {
  to {
    transform: rotate(360deg);
  }
}

.wa-nav-sep {
  margin: 0 6px;
  color: #adb5bd;
}
</style>
